import React, { Component } from "react";
import { AiFillSave } from "react-icons/ai";
import RahbarSlide from "../../MyFiles/Slide/RahbarTravel.png";

class RahbarTravel extends Component {
  constructor(props) {
    super(props);
    this.getRequest();
  }
  state = {
    userRequestJson: [],
    errorMessage: "",
    stepNo: 1,
    isHomePage: true,
  };
  componentDidMount() {
    this.getRequest();
  }
  getRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("CompetitionRequestTypeRef", 8);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-competition-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userRequestJson: myObject.data }, function() {});
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  handleValue(event) {
    this.setState({ exchangeCode: event.target.value });
  }
  render() {
    const myRequest = this.state.userRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <div className="mb-2">
          <span className="bg-dark text-white wp-text-small rounded p-1">
            تاریخ ثبت اطلاعات {e.RequestTime}
          </span>
        </div>
        <div className="title mb-2 text-dark text-center">
          <strong>درخواست حضور شما در مراسم تشییع پیکر مطهر آقای شهید ایران در سیستم ثبت شده است، منتظر اطلاع رسانی های بعدی سازمان باشید.</strong>
        </div>
      </li>
    ));
    if (this.state.isHomePage === true) {
      return (
        <div className="w-100 body-padding">
          <React.Fragment>
          <div className="col-12 px-0 mt-2">
            <React.Fragment>
                    <img className="w-100" src={RahbarSlide} alt="رهبر شهید" ></img>
              </React.Fragment>
            </div>
            {/* <p className="wp-header text-center text-danger">آقای شهید ایران</p> */}
            <ul className="Array p-0">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="item text-center">
                    <div className="alert alert-info te">
                      <p className="mb-2 text-center font-weight-bold">شرایط ثبت نام کاروان تشییع رهبر شهید امام سیدعلی خامنه‌ای در شهر مقدس قم:</p>
                      <p className="mb-0 text-right">- فقط برای پرسنل سالکو امکان ثبت نام میسر می‌باشد.</p>
                      <p className="mb-0 text-right">- پس از اتمام ثبت نام نفرات بر اساس قرعه کشی مشخص خواهد شد.</p>
                      <p className="mb-0 text-right">- ثبت نام در این مرحله مقدماتی است و برای تکمیل فرآیند با شما تماس گرفته خواهد شد.</p>
                      <p className="mb-0 text-right">- هزینه به ازای هر نفر: 500.000 تومان می‌باشد.</p>
                      <p className="mb-0 text-right">- ظرفیت: 40 نفر</p>
                      <p className="mb-0 text-right">- تاریخ حرکت: 14 الی 17 تیر 1405</p>
                      <p className="mb-0 text-right">- ایاب و ذهاب و اسکان بر عهده شرکت می‌باشد.</p>
                    </div>
                    <div className="w-100">
                    اینجانب <b>{this.props.userJson.full_name}</b> با کد
                      پرسنلی <b>{this.props.userJson.personeliCode}</b> آمادگی خود را برای حضور در مراسم تشییع پیکر مطهّر آقای شهید ایران در شهر مقدس قم اعلام می‌دارم.

                    </div>
                    <div className="text-left mt-2">
                      <button
                        id="SubmitForm"
                        className="btn dina-btn-blue rounded-0"
                        onClick={this.submitForm}
                      >
                        <AiFillSave /> ثبت نام اولیه
                      </button>
                    </div>
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
          </React.Fragment>
        </div>
      );
    }
  }
  submitForm = () => {
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("RequestType", "Rahbar");
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-rahbar-travel-request`,
          requestOptions,
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                errorMessage = "اطلاعات شما با موفقیت در سیستم ثبت شد.";
                this.props.getFullProfile();
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
                this.getRequest();
              } else {
                errorMessage = myObject.message;
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
              }
            }
          })
          .catch((error) => console.log("error", error));
      
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
}
export default RahbarTravel;